import React from "react";
import { Button, Icon } from "@culturehq/components";

import { useIsMobile } from "app/hooks";
import { t, Trans } from "app/utils";
import Timer from "../Timer";
import { ManualStatus } from "./EffectsSDKCameraRecorder";

interface CameraButtonsProps {
  effectsIsReady: boolean;
  manualStatus: ManualStatus;
  onConfirmClose: () => void;
  onFinishRecord: () => void;
  onPause: () => void;
  onResume: () => void;
  onRetake: () => void;
  onStartCountdown: () => void;
  recordEffects: boolean;
  screenRecord: boolean;
  showCountdown: boolean;
}

const CameraButtons: React.FC<CameraButtonsProps> = ({
  effectsIsReady,
  manualStatus,
  onConfirmClose,
  onFinishRecord,
  onPause,
  onResume,
  onRetake,
  onStartCountdown,
  recordEffects,
  screenRecord,
  showCountdown
}) => {
  const isMobile = useIsMobile();

  return (
    <div className="Video-Preview__Container-Top">
      {(recordEffects || screenRecord) && (manualStatus === "recording" || manualStatus === "paused") && <Timer pause={manualStatus !== "recording"} />}
      <div className="Button-Container">
        {manualStatus !== "stopped"
        && (
          <>
            {!isMobile && (manualStatus === "recording" || manualStatus === "paused") && (
              <Button
                aria-label={t("Cancel record")}
                inverted
                disabled={!effectsIsReady}
                icon="refresh"
                onClick={onRetake}
              >
                <Trans>Retake</Trans>
              </Button>
            )}
            {(manualStatus === "recording" && !screenRecord && !isMobile) && (
              <Button
                aria-label={t("Pause record")}
                onClick={onPause}
                icon="pause"
                className="Button-Gray"
              >
                <Trans>Pause</Trans>
              </Button>
            )}
            {(manualStatus === "paused" && !isMobile)
              && (
                <Button
                  aria-label={t("Resume record")}
                  onClick={onResume}
                  icon="play-filled"
                  className="Button-Gray"
                >
                  <Trans>Resume</Trans>
                </Button>
              )}
            {(manualStatus !== "recording") && (manualStatus !== "paused") && !isMobile
              && (
                <Button disabled={!effectsIsReady || showCountdown} icon="checkmark-filled" onClick={onStartCountdown}>
                  <Trans>Start Recording</Trans>
                </Button>
              )}
            {((manualStatus === "recording" || manualStatus === "paused") && !isMobile)
              && (
                <Button
                  className="Button-Record"
                  aria-label={t("Finish record")}
                  onClick={onFinishRecord}
                  icon="checkmark-filled"
                >
                  <Trans>Finish</Trans>
                </Button>
              )}
            <Icon className="Video-Preview__Container-Top__icon" icon="close" onClick={onConfirmClose} />
          </>
        )}
      </div>
    </div>
  );
};

export default CameraButtons;
